import React, { useState,useContext } from "react";
import ManageAccessCodeStepOne from "./ManageAccessCodeStepOne";
import ManageAccessCodeStepTwo from "./ManageAccessCodeStepTwo";
import { Loader } from "../../components/loader/Loader";
import { Button } from "@activehub/common-components-spa-resource";
import AccessCodeModal from "../generateaccesscode/GenerateAccessCode";
import "./ManageAccessCode.scss";
import { AppContext } from '../../App';

const ManageAccessCode = () => {
      const appContext = useContext(AppContext);
        const {
            isSuperAdmin
  } = appContext;
    const [isLoading, setIsLoading] = useState(false);
    const [showGenerateAccessCodeModal, setShowGenerateAccessCodeModal] = useState(false);
    return (
        <div className="manage-access-code">
            {isLoading && <Loader />}
            <div className="manage-access-codes-heading">
                <div className="heading-title">Manage access code orders</div>
                {isSuperAdmin && (
                <Button
                    useButtonClass={false}
                    className="generate-access-codes-btn"
                    onClick={() => setShowGenerateAccessCodeModal(true)}
                >
                    <img src={`${process.env.PUBLIC_URL}/images/add-blue.svg`} alt="Generate Access Codes" />
                    <span>Generate Access Codes</span>
                </Button>
                )}
            </div>
            {showGenerateAccessCodeModal && (
                <AccessCodeModal 
                isOpen={showGenerateAccessCodeModal}
                onClose={() => setShowGenerateAccessCodeModal(false)} />
            )}
            <ManageAccessCodeStepOne setIsLoading={setIsLoading} />
            <ManageAccessCodeStepTwo setIsLoading={setIsLoading} isLoading={isLoading} />
        </div>
    )
}
export default ManageAccessCode;